module.exports = __webpack_public_path__ + "img/home_point_double.a1387159.png";